import React from 'react';
import './Terms.css';

const Terms = ({ onClose }) => {
  return (
    <div className="terms-overlay">
      <div className="terms-modal">
        <div className="terms-header">
          <h2>Terms of Service</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="terms-content">
          <p>By using this service, you agree to the following terms:</p>
          
          <h3>Account Security</h3>
          <ul>
            <li>You may not share your login credentials with anyone</li>
            <li>If your credentials are compromised, contact the operator immediately and change your password if possible</li>
          </ul>
          
          <h3>Usage Guidelines</h3>
          <ul>
            <li>Use of this service is unlimited, but please be respectful and reasonable in your usage</li>
            <li>Don't abuse the system or engage in behavior that could harm the service or other users</li>
          </ul>
          
          <h3>Prohibited Uses</h3>
          <ul>
            <li>This platform must not be used for any illegal purposes</li>
            <li>Usage must comply with AWS Terms of Service and AWS Bedrock Terms of Service</li>
            <li>Any activity that violates applicable laws or regulations is strictly prohibited</li>
          </ul>
          
          <h3>Disclaimer</h3>
          <p>
            To the fullest extent permitted by law, the service owner is not liable for any misuse 
            of this service by users. You use this service at your own risk and are responsible 
            for ensuring your usage complies with all applicable terms and laws.
          </p>
          
          <p className="terms-footer">
            These terms may be updated from time to time. Continued use of the service 
            constitutes acceptance of any changes.
          </p>
        </div>
        
        <div className="terms-actions">
          <button className="accept-button" onClick={onClose}>I Understand</button>
        </div>
      </div>
    </div>
  );
};

export default Terms;